import { useState } from "react";
import { useDebounceValue } from "usehooks-ts";
import { VersionsExportCsv } from "./versions-export-csv";
import { VersionsSearch } from "./versions-search";
import { VersionsSort } from "./versions-sort";
import { VersionsTableWrapper } from "./versions-table-wrapper";
import { VersionsUnreadToggle } from "./versions-unread-toggle";

export const VersionsTable = () => {
  const [sortBy, setSortBy] = useState("created-date");
  const [sortDirection, setSortDirection] = useState("desc");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounceValue(searchTerm, 500);
  return (
    <div className="-xl:tw-px-4">
      <div className="tw-shadow-2xs tw-rounded-xl tw-mb-6 tw-outline tw-outline-1 tw-outline-blue/5 tw-bg-white tw-p-5">
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-4">
          <span className="tw-text-base tw-font-semibold tw-text-blue tw-font-sans tw-block">
            Versions
          </span>
          <VersionsUnreadToggle isMobile />
        </div>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6 -md:tw-flex-row-reverse -sm:tw-gap-2">
          <div className="tw-flex tw-items-center tw-gap-2">
            <VersionsSort
              sortBy={sortBy}
              setSortBy={setSortBy}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
            />
            <VersionsUnreadToggle />
          </div>
          <div className="tw-flex tw-items-center tw-gap-2 -sm:tw-flex-1">
            <VersionsSearch
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
            <VersionsExportCsv />
          </div>
        </div>
        <VersionsTableWrapper
          sortBy={sortBy}
          sortDirection={sortDirection}
          searchTerm={debouncedSearchTerm}
        />
      </div>
    </div>
  );
};
